import * as Yup from 'yup';

export const validationSchema = Yup.object({
  date: Yup.date().nullable(),
  historyDate: Yup.date().nullable(),
  vitals: Yup.object({
    systolicBP: Yup.number()
      .nullable()
      .transform((value, originalValue) => originalValue === '' ? null : value)
      .min(70, 'Systolic BP must be at least 70 mmHg')
      .max(300, 'Systolic BP must be less than 300 mmHg'),
    diastolicBP: Yup.number()
      .nullable()
      .transform((value, originalValue) => originalValue === '' ? null : value)
      .min(40, 'Diastolic BP must be at least 40 mmHg')
      .max(200, 'Diastolic BP must be less than 200 mmHg')
      .test('diastolic-less-than-systolic', 'Diastolic BP must be less than Systolic BP', function(value) {
        const { systolicBP } = this.parent;
        if (!value || !systolicBP) return true;
        return value < systolicBP;
      }),
    heartRate: Yup.number()
      .nullable()
      .transform((value, originalValue) => originalValue === '' ? null : value)
      .min(30, 'Heart rate must be at least 30 BPM')
      .max(300, 'Heart rate must be less than 300 BPM'),
    fastingBloodSugar: Yup.number()
      .nullable()
      .transform((value, originalValue) => originalValue === '' ? null : value)
      .min(0, 'Fasting blood sugar cannot be negative')
      .max(600, 'Fasting blood sugar must be less than 600 mg/dl'),
    postPrandialBloodSugar: Yup.number()
      .nullable()
      .transform((value, originalValue) => originalValue === '' ? null : value)
      .min(0, 'Post prandial blood sugar cannot be negative')
      .max(600, 'Post prandial blood sugar must be less than 600 mg/dl')
      .test('sugar-required', 'Either PPBS or RBS must be filled', function(value) {
        const { randomBloodSugar } = this.parent || {};
        return (value !== null && value !== undefined && value !== '') || 
               (randomBloodSugar !== null && randomBloodSugar !== undefined && randomBloodSugar !== '');
      }),
    randomBloodSugar: Yup.number()
      .nullable()
      .transform((value, originalValue) => originalValue === '' ? null : value)
      .min(0, 'Random blood sugar cannot be negative')
      .max(600, 'Random blood sugar must be less than 600 mg/dl')
      .test('sugar-required-random', 'Either PPBS or RBS must be filled', function(value) {
        const { postPrandialBloodSugar } = this.parent || {};
        return (value !== null && value !== undefined && value !== '') || 
               (postPrandialBloodSugar !== null && postPrandialBloodSugar !== undefined && postPrandialBloodSugar !== '');
      }),
    postPrandialBloodSugarType: Yup.string()
      .nullable()
      .test('type-required-for-ppbs', 'Please select blood sugar type', function(value) {
        const { postPrandialBloodSugar } = this.parent || {};
        const hasPpbs = postPrandialBloodSugar !== null && postPrandialBloodSugar !== undefined && postPrandialBloodSugar !== '';
        if (hasPpbs) {
          return value !== null && value !== undefined && value !== '';
        }
        return true;
      }),
    randomBloodSugarType: Yup.string()
      .nullable()
      .test('type-required-for-rbs', 'Please select blood sugar type', function(value) {
        const { randomBloodSugar } = this.parent || {};
        const hasRbs = randomBloodSugar !== null && randomBloodSugar !== undefined && randomBloodSugar !== '';
        if (hasRbs) {
          return value !== null && value !== undefined && value !== '';
        }
        return true;
      }),
    hba1c: Yup.number()
      .nullable()
      .transform((value, originalValue) => originalValue === '' ? null : value)
      .min(0, 'HbA1c cannot be negative')
      .max(20, 'HbA1c must be less than 20%'),
    height: Yup.number()
      .nullable()
      .transform((value, originalValue) => originalValue === '' ? null : value)
      .min(50, 'Height must be at least 50 cm')
      .max(300, 'Height must be less than 300 cm'),
    weight: Yup.number()
      .nullable()
      .transform((value, originalValue) => originalValue === '' ? null : value)
      .min(10, 'Weight must be at least 10 kg')
      .max(500, 'Weight must be less than 500 kg'),
    bmi: Yup.number()
      .nullable()
      .transform((value, originalValue) => originalValue === '' ? null : value)
      .min(0, 'BMI cannot be negative'),
    waistCircumference: Yup.string().nullable()
  })
});
